import { Col, Row } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import FormBox from "../components/FormBox.jsx";
import PhoneInput from "../components/login/PhoneInput.js";
import profilebanner from "../assets/img/profile-banner.png";
import profileimg from "../assets/img/profile-img.png";

import { LiaAngleLeftSolid } from "react-icons/lia";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import Table from "react-bootstrap/Table";
import { CiEdit } from "react-icons/ci";
import { LuPlus } from "react-icons/lu";
import Api from "../api/api.js";
import brokerjson from "../services/Helpers/BrokerFields.json";
import { toast } from "react-toastify";
import PaginationComponent from "../components/PaginationComponent/PaginationComponent.js";
import moment from "moment/moment.js";
import { useLocation, useNavigate } from "react-router-dom";
import Aesfile from '../services/Utils/aes.js';
import notificationsIcon from "../assets/images/notifications.webp";
const options = Object.keys(brokerjson).map((key) => ({
  value: key,
  label: key,
}));

export default function Profile() {
  const initialValues = {
    broker_name: "",
    user_id: JSON.parse(localStorage.getItem("user_details")).user_id,
    // state_cd: "test",
  };
  const [values, setValues] = useState(initialValues);
  const [currentPage, setcurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(1)
  const convertarraytoobject = (data) => {
    const options = data.map((key) => ({
      value: key,
      label: key,
    }));
    return options;
  };

  const [allBrokers, setallBrokers] = useState([]);
  const [brokers, setBrokers] = useState([]);
  const [notification, setNotification] = useState([]);
  const [isedit, setIsEdit] = useState(false);
  const [input, setInput] = useState([]);
  const [isBrokerFieldDisabled, setBrokerDisable] = useState(false);
  const [DelModal, setDelModal] = useState(false);
  const [DelItem, SetDelItem] = useState({});
  const [errors, setErrors] = useState("");
  const [subscription, setsubscription] = useState([])
  const [addBroker, setAddBroker] = useState(false);
  const [notificationFilter, setNotificationFilter] = useState('all');
  let [user, setUser] = useState(null);

  useEffect(() => {
    getProfile();
    getBrokers();
    getNotification();
    getSubscriptions();
  }, []);

  async function getNotification(page) {
    const payload = {
      offset: page !== undefined ? page : currentPage,
    };
    try {
      let res = await Api.notification(payload);
      // API returns { message, offset, total_pages, data }
      if (res && res.data) {
        // Map notify_ts to created_at for consistency
        const notifications = res.data.map(notif => ({
          ...notif,
          created_at: notif.notify_ts || notif.created_at || notif.timestamp
        }));
        setNotification(notifications);
        setcurrentPage(res.offset || 1);
        settotalPages(res.total_pages || 1);
      } else {
        setNotification([]);
        setcurrentPage(1);
        settotalPages(1);
      }
    } catch (error) {
      console.error("Error while fetching notifications:", error);
      alert("Error while fetching notifications");
      setNotification([]);
    }
  }

  // Helper function to format time
  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    try {
      const date = new Date(timestamp);
      const now = new Date();
      const diff = now - date;
      const minutes = Math.floor(diff / 60000);
      const hours = Math.floor(diff / 3600000);
      const days = Math.floor(diff / 86400000);

      if (minutes < 1) return 'Just now';
      if (minutes < 60) return `${minutes} min${minutes > 1 ? 's' : ''} ago`;
      if (hours < 24) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
      if (days < 7) return `${days} day${days > 1 ? 's' : ''} ago`;
      return date.toLocaleDateString();
    } catch (e) {
      return '';
    }
  };

  // Mark single notification as read
  const markAsRead = async (notifyId) => {
    try {
      await Api.notificationUpdate({
        'notify_id': notifyId,
        'action': 'UPDATE'
      });
      getNotification(currentPage); // Refresh list
    } catch (error) {
      alert('Error marking notification as read');
    }
  };

  // Mark all notifications as read
  const markAllAsRead = async () => {
    try {
      const unreadNotifications = notification.filter(n => n.read_ind === 'U');
      await Promise.all(
        unreadNotifications.map(n => 
          Api.notificationUpdate({
            'notify_id': n.notify_id,
            'action': 'UPDATE'
          })
        )
      );
      getNotification(currentPage);
    } catch (error) {
      alert('Error marking all as read');
    }
  };

  // Check if there are unread notifications
  const hasUnreadNotifications = () => {
    return notification.some(n => n.read_ind === 'U');
  };

  // Delete notification
  const deleteNotification = async (notifyId) => {
    if (window.confirm('Are you sure you want to delete this notification?')) {
      try {
        await Api.notificationUpdate({
          'notify_id': notifyId,
          'action': 'DELETE'
        });
        getNotification(currentPage);
      } catch (error) {
        alert('Error deleting notification');
      }
    }
  };

  // Filter notifications
  const filterNotifications = (filter) => {
    setNotificationFilter(filter);
  };

  const getFilteredNotifications = () => {
    if (notificationFilter === 'all') return notification;
    if (notificationFilter === 'unread') return notification.filter(n => n.read_ind === 'U');
    if (notificationFilter === 'read') return notification.filter(n => n.read_ind === 'R');
    return notification;
  };
  async function createBrokers(param) {
    let broker_obj = {};
    let valid_data = true;
    let err = "";
    if (param["action"]) {
      broker_obj = param;
    } else {
      broker_obj = values;
      input.forEach((field) => {
        const fieldValue = broker_obj[field.field_name];
        if (
          field.mandatory === "Y" &&
          (!fieldValue ||
            (Array.isArray(fieldValue)
              ? fieldValue.length === 0
              : fieldValue.trim() === ""))
        ) {
          valid_data = false;
        }
      });

      if (
        !broker_obj["broker_name"] ||
        broker_obj["broker_name"].trim() === ""
      ) {
        valid_data = false;
      }

      // Duplicate check
      brokers.forEach((item) => {
        if (
          item.username === broker_obj["username"] &&
          item.broker_name === broker_obj["broker_name"]
        ) {
          if (broker_obj["action"] === "UPDATE") {
            if (item.broker_id !== broker_obj["broker_id"]) {
              valid_data = false;
            }
          } else {
            err = `Username "${broker_obj["username"]}" is already added for broker "${broker_obj["broker_name"]}".`;
            valid_data = false;
          }

          // if (!valid_data) {
          //   err = `Username "${broker_obj["username"]}" is already added for broker "${broker_obj["broker_name"]}".`;
          // }
        }
      });
    }

    if (!valid_data) {
      toast.error(err ? err : "Select all fields");
      //setErrors(err ? err : "Select all fields");
      return;
    }

    try {
      const jsonString = JSON.stringify(broker_obj);
      const payload = await Aesfile.encryptPayload(jsonString)
      let res = await Api.createBrokers({ data: payload });
      setDelModal(false);
      setAddBroker(false);
      setValues(initialValues);
      setErrors();
      getBrokers();
    } catch (error) {
      console.log(error);
    }
  }

  async function handleupdateProfile() {
    try {
      let res = await Api.profileUpdate(user);
      setIsEdit(false);
      toast.success(res?.message)
      getProfile();
    } catch (error) {
      console.log(error);
    }
  }

  async function getProfile() {
    try {
      let res = await Api.profile();
      setUser(res?.data[0]);
    } catch (error) {
      alert("Error while Get Profile");
    }
  }

  async function getSubscriptions() {
    try {
      let res = await Api.subscriptions();
      const mergedSubscriptions = Object.entries(res?.message).flatMap(([statusKey, items]) =>
        items.map(item => ({
          ...item,
          status: statusKey.charAt(0).toUpperCase() + statusKey.slice(1)
        }))
      );
      setsubscription(mergedSubscriptions)
    } catch (error) {
      alert("Error while subscriptions");
    }
  }

  async function getBrokers() {
    try {
      let aesRes = await Api.brokers();
      var res = await Aesfile.decryptPayload(aesRes.data);
      setBrokers(res);
      setallBrokers(res);
    } catch (error) {
      alert("Error while fetching Strategies");
    }
  }

  function searchArray(query) {
    const lowerCaseQuery = query.target.value.toLowerCase();
    const result = allBrokers.filter((item) =>
      Object.values(item).some((value) =>
        value.toString().toLowerCase().includes(lowerCaseQuery)
      )
    );
    setBrokers(result);
  }

  function handlecEditchange(e) {
    setUser({ ...user, [e.target.name]: e.target.value });
  }

  const handleSelectChange = (selectedOption) => {
    const brokerName = selectedOption ? selectedOption.value : "";
    setValues((prevState) => ({
      ...prevState,
      broker_name: brokerName,
      action: "ADD",
    }));

    if (brokerName && brokerjson[brokerName]) {
      setInput(brokerjson[brokerName].fields);
    } else {
      setInput([]);
    }
  };

  function openModal(item) {
    setDelModal(true);
    SetDelItem(item);
  }

  const location = useLocation();
  const [activeTab, setActiveTab] = useState('my_profile');
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = params.get('page') || "my_profile";
    if (['my_profile', 'subscription', 'Broker', 'notification'].includes(page)) {
      setActiveTab(page);
    }
    else {
      setActiveTab('my_profile');
      navigate("/profile?page=my_profile");
    }
  }, []);

  const handleTabChange = (key) => {
    setActiveTab(key);
    navigate(`/profile?page=${key}`);
  };

  return (
    <>
      <div className="dashboard-wrap profile">
        <Tabs
          defaultActiveKey="my_profile"
          transition={false}
          id="noanim-tab-example"
          className="mb-3"
          activeKey={activeTab}
          onSelect={handleTabChange}
        >
          <Tab eventKey="my_profile" title="My Profile">
            <Row className="justify-content-center">
              <Col xs={8} lg={6} className="mb-4 mb-lg-0 mx-auto">
                <div className="profile-details">
                  <div className="position-relative z-0">
                    <div className="position-relative z-0">
                      <div className="image">
                        <img className="w-100" src={profilebanner} alt="" />
                      </div>
                    </div>
                    <div className="position-absolute z-2 start-50 translate-middle profile-area">
                      <div className="profile-img ">
                        <img src={profileimg} alt="" />
                      </div>
                    </div>
                  </div>
                  <div className="profile-history">
                    <div className="form-item d-lg-flex gap-3 mb-2 pb-1 w-100">
                      <FormBox
                        className="w-100 mb-2"
                        label="First Name"
                        name="first_name"
                        value={user?.first_name}
                        disabled={!isedit}
                        onChange={handlecEditchange}
                      />
                      <FormBox
                        className="w-100 mb-2"
                        label="Last Name"
                        name="last_name"
                        value={user?.last_name}
                        disabled={!isedit}
                        onChange={handlecEditchange}
                      />
                      <FormBox
                        className="w-100 mb-2"
                        label="Email Id"
                        name="email"
                        value={user?.email ? user.email : ""}
                        disabled={true}
                        onChange={handlecEditchange}
                      />
                    </div>
                    <div className="form-item  mb-2 pb-1">
                      {/*<PhoneInput
                        type="tel"
                        name="mobile"
                        value={user?.mobile}
                        onChange={handlecEditchange}
                        disabled={!isedit}
                      /> */}
                    </div>

                    <div className="form-item align-items-center  mb-2 pb-1"></div>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs={8} lg={6} className="mb-4 mb-lg-0 mx-auto">
                <button
                  className="btn bg-primary edit"
                  style={{
                    width: "100%",
                    marginTop: "20px"
                  }}
                  onClick={() => {
                    if (isedit) {
                      handleupdateProfile();
                    } else {
                      setIsEdit(!isedit);
                    }
                  }}
                >
                  {isedit ? "Update" : "Edit"}
                </button>
              </Col>
            </Row>
          </Tab>
          <Tab eventKey="subscriptions" title="Subscriptions">
            <div className="broken-table overflow-auto broken-area ">
              <Table>
                <thead>
                  <tr className="tableheader">
                    <th>
                      <div className="d-flex gap-1 align-items-center">
                        <p className="table-label">Plan Name</p>
                        <span></span>
                      </div>
                    </th>
                    <th>
                      <div className="d-flex gap-1 align-items-center">
                        <p className="table-label">Plan Description</p>
                        <span></span>
                      </div>
                    </th>
                    <th>
                      <div className="d-flex gap-1  align-items-center">
                        <p className="table-label">Status</p>
                        <span></span>
                      </div>
                    </th>
                    <th>
                      <div className="d-flex gap-1  align-items-center">
                        <p className="table-label">Start Date</p>
                        <span></span>
                      </div>
                    </th>
                    <th>
                      <div className="d-flex gap-1  align-items-center">
                        <p className="table-label">End Date</p>
                        <span></span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {subscription?.map((item, idx) => (
                    <tr key={idx}>
                      <td>
                        <p className="value">{item?.plan_name}</p>
                      </td>
                      <td>
                        <p className="value">{item?.plan_description}</p>
                      </td>
                      <td>
                        <p className="value">{item?.status}</p>
                      </td>
                      <td>
                        <p className="value">{moment(item?.start_date).format('DD-MM-YYYY')}</p>
                      </td>
                      <td>
                        <p className="value">{moment(item?.end_date).format('DD-MM-YYYY')} </p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Tab>
          <Tab eventKey="Broker" title="Broker">
            <div className="broken-area">
              <div className="broken-heading mb-3 d-sm-flex align-items-center gap-3 gap-md-0 justify-content-between">
                <div className="input-item position-relative">
                  <input
                    className="form-control border-0 fz-14 fw-normal"
                    type="text"
                    name=""
                    id=""
                    placeholder="Search"
                    onChange={(e) => searchArray(e)}
                  />
                  <div className="position-absolute lh-1 ms-2 ps-1 position-absolute top-50 translate-middle-y">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15.75 15.75L12.4927 12.4927M12.4927 12.4927C13.0499 11.9356 13.4919 11.2741 13.7934 10.5461C14.0949 9.81816 14.2501 9.03792 14.2501 8.24997C14.2501 7.46202 14.0949 6.68178 13.7934 5.95381C13.4919 5.22584 13.0499 4.56439 12.4927 4.00722C11.9356 3.45006 11.2741 3.00809 10.5461 2.70655C9.81816 2.40502 9.03792 2.24982 8.24997 2.24982C7.46202 2.24982 6.68178 2.40502 5.95381 2.70655C5.22584 3.00809 4.56439 3.45006 4.00722 4.00722C2.88197 5.13247 2.24982 6.65863 2.24982 8.24997C2.24982 9.84131 2.88197 11.3675 4.00722 12.4927C5.13247 13.618 6.65863 14.2501 8.24997 14.2501C9.84131 14.2501 11.3675 13.618 12.4927 12.4927Z"
                        stroke="#8E8F95"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M15.75 15.75L12.4927 12.4927M12.4927 12.4927C13.0499 11.9356 13.4919 11.2741 13.7934 10.5461C14.0949 9.81816 14.2501 9.03792 14.2501 8.24997C14.2501 7.46202 14.0949 6.68178 13.7934 5.95381C13.4919 5.22584 13.0499 4.56439 12.4927 4.00722C11.9356 3.45006 11.2741 3.00809 10.5461 2.70655C9.81816 2.40502 9.03792 2.24982 8.24997 2.24982C7.46202 2.24982 6.68178 2.40502 5.95381 2.70655C5.22584 3.00809 4.56439 3.45006 4.00722 4.00722C2.88197 5.13247 2.24982 6.65863 2.24982 8.24997C2.24982 9.84131 2.88197 11.3675 4.00722 12.4927C5.13247 13.618 6.65863 14.2501 8.24997 14.2501C9.84131 14.2501 11.3675 13.618 12.4927 12.4927Z"
                        stroke="black"
                        strokeOpacity="0.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <button className="filter position-absolute top-50 translate-middle-y end-0 me-1 p-0 border-0 bg-secondary text-white">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.88924 1.3125H11.1107C11.4998 1.3125 11.8323 1.3125 12.0983 1.34575C12.3801 1.38133 12.6525 1.46125 12.8765 1.67125C13.104 1.88533 13.1944 2.15192 13.2341 2.429C13.2708 2.68392 13.2708 3.00067 13.2708 3.36233V3.815C13.2708 4.10025 13.2708 4.34583 13.2498 4.55175C13.2265 4.77342 13.1769 4.9805 13.0567 5.17942C12.9372 5.37717 12.7767 5.52067 12.5912 5.649C12.4168 5.77033 12.1946 5.89575 11.9321 6.04333L10.2159 7.00933C9.82507 7.22925 9.68916 7.30858 9.59816 7.38733C9.38991 7.56817 9.27032 7.76942 9.21432 8.02083C9.19041 8.12875 9.18749 8.26408 9.18749 8.67592V10.2696C9.18749 10.7952 9.18749 11.2414 9.13324 11.585C9.07607 11.9496 8.94249 12.2996 8.59249 12.5183C8.25007 12.7324 7.87382 12.7126 7.50749 12.6257C7.15457 12.5422 6.71999 12.3719 6.19849 12.1683L6.14832 12.1485C5.90332 12.0528 5.68982 11.9694 5.52066 11.8819C5.33866 11.788 5.16949 11.6713 5.04057 11.4893C4.90932 11.305 4.85741 11.1078 4.83349 10.906C4.81249 10.7222 4.81249 10.5017 4.81249 10.2556V8.67592C4.81249 8.26408 4.81016 8.12875 4.78566 8.02083C4.7327 7.77247 4.59745 7.54925 4.40182 7.38733C4.31082 7.30858 4.17432 7.22925 3.78407 7.00933L2.06791 6.04333C1.80541 5.89575 1.58316 5.77033 1.40874 5.649C1.22324 5.52067 1.06282 5.37717 0.94324 5.17942C0.823073 4.9805 0.77349 4.77283 0.75074 4.55175C0.729156 4.34642 0.729156 4.10025 0.729156 3.815V3.36233C0.729156 3.00067 0.729156 2.68392 0.765906 2.429C0.805573 2.15192 0.89599 1.88533 1.12349 1.67125C1.34749 1.46125 1.61932 1.38133 1.90166 1.34575C2.16766 1.3125 2.50016 1.3125 2.88924 1.3125ZM2.01132 2.21433C1.81649 2.23883 1.75466 2.2785 1.72257 2.30942C1.69341 2.33625 1.65607 2.3835 1.63157 2.55325C1.60532 2.73875 1.60416 2.99192 1.60416 3.39208V3.79458C1.60416 4.10608 1.60416 4.30675 1.62049 4.46192C1.63566 4.606 1.66132 4.67542 1.69282 4.72733C1.72491 4.78042 1.77857 4.8405 1.90749 4.93033C2.04399 5.02483 2.23007 5.13042 2.51416 5.29025L4.21341 6.24692L4.26007 6.27317C4.58674 6.45692 4.80841 6.58175 4.97524 6.72642C5.31265 7.01106 5.54646 7.3993 5.64024 7.83067C5.68749 8.04475 5.68749 8.28567 5.68749 8.624V10.2334C5.68749 10.5087 5.68807 10.6779 5.70324 10.8051C5.71607 10.9206 5.73766 10.9597 5.75341 10.9824C5.77091 11.0069 5.80591 11.0448 5.92199 11.1049C6.04566 11.1685 6.21657 11.2356 6.48607 11.3412C7.04666 11.5605 7.42407 11.7069 7.70932 11.7746C7.98874 11.8411 8.08091 11.8067 8.12816 11.7769C8.16782 11.7518 8.22907 11.7011 8.26932 11.4485C8.31132 11.1819 8.31249 10.8051 8.31249 10.2328V8.624C8.31249 8.28567 8.31249 8.04475 8.36032 7.83067C8.45395 7.39938 8.68754 7.01115 9.02474 6.72642C9.19157 6.58175 9.41382 6.45633 9.73932 6.27317L9.78657 6.24692L11.4858 5.29025C11.7699 5.13042 11.956 5.02483 12.0925 4.93033C12.2214 4.8405 12.2751 4.78042 12.3072 4.72733C12.3387 4.67542 12.3643 4.606 12.3789 4.46192C12.3952 4.30675 12.3958 4.10608 12.3958 3.794V3.3915C12.3958 2.99192 12.3947 2.73817 12.3684 2.55325C12.3439 2.3835 12.306 2.33625 12.278 2.30942C12.2453 2.27908 12.1835 2.23883 11.9887 2.21433C11.7845 2.18808 11.5074 2.1875 11.0833 2.1875H2.91666C2.49257 2.1875 2.21607 2.18808 2.01132 2.21433Z"
                        fill="currentColor"
                      />
                    </svg>
                  </button>
                </div>
                <button
                  onClick={() => {
                    setValues(initialValues);
                    setAddBroker(!addBroker);
                    setInput([]);
                    setBrokerDisable(true);
                  }}
                  className="bg-primary mt-2 mt-md-0 btn fs-6 fw-medium d-flex align-items-center  gap-2"
                >
                  <LuPlus />
                  Add New
                </button>
              </div>
              <div className="broken-table overflow-auto ">
                <Table>
                  <thead>
                    <tr className="tableheader">
                      <th>
                        <div className="d-flex gap-1 align-items-center">
                          <p className="table-label">Broker</p>
                          <span>
                            <svg
                              width="14"
                              height="15"
                              viewBox="0 0 14 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.99879 4.60265C1.94309 4.55003 1.87758 4.50888 1.80599 4.48157C1.7344 4.45427 1.65813 4.44132 1.58154 4.44349C1.50494 4.44566 1.42953 4.46289 1.35959 4.4942C1.28966 4.52551 1.22658 4.5703 1.17395 4.62599C1.12132 4.68168 1.08018 4.74719 1.05287 4.81878C1.02556 4.89037 1.01262 4.96664 1.01479 5.04324C1.01696 5.11983 1.03419 5.19525 1.0655 5.26518C1.09681 5.33511 1.14159 5.39819 1.19729 5.45082L6.44729 10.4092C6.55559 10.5115 6.69899 10.5686 6.84804 10.5686C6.99708 10.5686 7.14048 10.5115 7.24879 10.4092L12.4994 5.45082C12.5563 5.39854 12.6022 5.33547 12.6346 5.26528C12.6669 5.19509 12.685 5.11918 12.6877 5.04195C12.6904 4.96472 12.6778 4.88771 12.6505 4.8154C12.6233 4.74309 12.5819 4.67692 12.5289 4.62074C12.4758 4.56455 12.4121 4.51947 12.3415 4.4881C12.2709 4.45674 12.1947 4.43972 12.1174 4.43804C12.0402 4.43636 11.9634 4.45004 11.8914 4.4783C11.8195 4.50656 11.7539 4.54883 11.6985 4.60265L6.84804 9.18299L1.99879 4.60265Z"
                                fill="#8E8F95"
                              />
                              <path
                                d="M1.99879 4.60265C1.94309 4.55003 1.87758 4.50888 1.80599 4.48157C1.7344 4.45427 1.65813 4.44132 1.58154 4.44349C1.50494 4.44566 1.42953 4.46289 1.35959 4.4942C1.28966 4.52551 1.22658 4.5703 1.17395 4.62599C1.12132 4.68168 1.08018 4.74719 1.05287 4.81878C1.02556 4.89037 1.01262 4.96664 1.01479 5.04324C1.01696 5.11983 1.03419 5.19525 1.0655 5.26518C1.09681 5.33511 1.14159 5.39819 1.19729 5.45082L6.44729 10.4092C6.55559 10.5115 6.69899 10.5686 6.84804 10.5686C6.99708 10.5686 7.14048 10.5115 7.24879 10.4092L12.4994 5.45082C12.5563 5.39854 12.6022 5.33547 12.6346 5.26528C12.6669 5.19509 12.685 5.11918 12.6877 5.04195C12.6904 4.96472 12.6778 4.88771 12.6505 4.8154C12.6233 4.74309 12.5819 4.67692 12.5289 4.62074C12.4758 4.56455 12.4121 4.51947 12.3415 4.4881C12.2709 4.45674 12.1947 4.43972 12.1174 4.43804C12.0402 4.43636 11.9634 4.45004 11.8914 4.4783C11.8195 4.50656 11.7539 4.54883 11.6985 4.60265L6.84804 9.18299L1.99879 4.60265Z"
                                fill="black"
                                fillOpacity="0.2"
                              />
                            </svg>
                          </span>
                        </div>
                      </th>
                      <th>
                        <div className="d-flex gap-1 align-items-center">
                          <p className="table-label">Username</p>
                          <span>
                            <svg
                              width="14"
                              height="15"
                              viewBox="0 0 14 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.99879 4.60265C1.94309 4.55003 1.87758 4.50888 1.80599 4.48157C1.7344 4.45427 1.65813 4.44132 1.58154 4.44349C1.50494 4.44566 1.42953 4.46289 1.35959 4.4942C1.28966 4.52551 1.22658 4.5703 1.17395 4.62599C1.12132 4.68168 1.08018 4.74719 1.05287 4.81878C1.02556 4.89037 1.01262 4.96664 1.01479 5.04324C1.01696 5.11983 1.03419 5.19525 1.0655 5.26518C1.09681 5.33511 1.14159 5.39819 1.19729 5.45082L6.44729 10.4092C6.55559 10.5115 6.69899 10.5686 6.84804 10.5686C6.99708 10.5686 7.14048 10.5115 7.24879 10.4092L12.4994 5.45082C12.5563 5.39854 12.6022 5.33547 12.6346 5.26528C12.6669 5.19509 12.685 5.11918 12.6877 5.04195C12.6904 4.96472 12.6778 4.88771 12.6505 4.8154C12.6233 4.74309 12.5819 4.67692 12.5289 4.62074C12.4758 4.56455 12.4121 4.51947 12.3415 4.4881C12.2709 4.45674 12.1947 4.43972 12.1174 4.43804C12.0402 4.43636 11.9634 4.45004 11.8914 4.4783C11.8195 4.50656 11.7539 4.54883 11.6985 4.60265L6.84804 9.18299L1.99879 4.60265Z"
                                fill="#8E8F95"
                              />
                              <path
                                d="M1.99879 4.60265C1.94309 4.55003 1.87758 4.50888 1.80599 4.48157C1.7344 4.45427 1.65813 4.44132 1.58154 4.44349C1.50494 4.44566 1.42953 4.46289 1.35959 4.4942C1.28966 4.52551 1.22658 4.5703 1.17395 4.62599C1.12132 4.68168 1.08018 4.74719 1.05287 4.81878C1.02556 4.89037 1.01262 4.96664 1.01479 5.04324C1.01696 5.11983 1.03419 5.19525 1.0655 5.26518C1.09681 5.33511 1.14159 5.39819 1.19729 5.45082L6.44729 10.4092C6.55559 10.5115 6.69899 10.5686 6.84804 10.5686C6.99708 10.5686 7.14048 10.5115 7.24879 10.4092L12.4994 5.45082C12.5563 5.39854 12.6022 5.33547 12.6346 5.26528C12.6669 5.19509 12.685 5.11918 12.6877 5.04195C12.6904 4.96472 12.6778 4.88771 12.6505 4.8154C12.6233 4.74309 12.5819 4.67692 12.5289 4.62074C12.4758 4.56455 12.4121 4.51947 12.3415 4.4881C12.2709 4.45674 12.1947 4.43972 12.1174 4.43804C12.0402 4.43636 11.9634 4.45004 11.8914 4.4783C11.8195 4.50656 11.7539 4.54883 11.6985 4.60265L6.84804 9.18299L1.99879 4.60265Z"
                                fill="black"
                                fillOpacity="0.2"
                              />
                            </svg>
                          </span>
                        </div>
                      </th>
                      <th>
                        <div className="d-flex gap-1  align-items-center">
                          <p className="table-label">Exchanges</p>
                          <span>
                            <svg
                              width="14"
                              height="15"
                              viewBox="0 0 14 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.99879 4.60265C1.94309 4.55003 1.87758 4.50888 1.80599 4.48157C1.7344 4.45427 1.65813 4.44132 1.58154 4.44349C1.50494 4.44566 1.42953 4.46289 1.35959 4.4942C1.28966 4.52551 1.22658 4.5703 1.17395 4.62599C1.12132 4.68168 1.08018 4.74719 1.05287 4.81878C1.02556 4.89037 1.01262 4.96664 1.01479 5.04324C1.01696 5.11983 1.03419 5.19525 1.0655 5.26518C1.09681 5.33511 1.14159 5.39819 1.19729 5.45082L6.44729 10.4092C6.55559 10.5115 6.69899 10.5686 6.84804 10.5686C6.99708 10.5686 7.14048 10.5115 7.24879 10.4092L12.4994 5.45082C12.5563 5.39854 12.6022 5.33547 12.6346 5.26528C12.6669 5.19509 12.685 5.11918 12.6877 5.04195C12.6904 4.96472 12.6778 4.88771 12.6505 4.8154C12.6233 4.74309 12.5819 4.67692 12.5289 4.62074C12.4758 4.56455 12.4121 4.51947 12.3415 4.4881C12.2709 4.45674 12.1947 4.43972 12.1174 4.43804C12.0402 4.43636 11.9634 4.45004 11.8914 4.4783C11.8195 4.50656 11.7539 4.54883 11.6985 4.60265L6.84804 9.18299L1.99879 4.60265Z"
                                fill="#8E8F95"
                              />
                              <path
                                d="M1.99879 4.60265C1.94309 4.55003 1.87758 4.50888 1.80599 4.48157C1.7344 4.45427 1.65813 4.44132 1.58154 4.44349C1.50494 4.44566 1.42953 4.46289 1.35959 4.4942C1.28966 4.52551 1.22658 4.5703 1.17395 4.62599C1.12132 4.68168 1.08018 4.74719 1.05287 4.81878C1.02556 4.89037 1.01262 4.96664 1.01479 5.04324C1.01696 5.11983 1.03419 5.19525 1.0655 5.26518C1.09681 5.33511 1.14159 5.39819 1.19729 5.45082L6.44729 10.4092C6.55559 10.5115 6.69899 10.5686 6.84804 10.5686C6.99708 10.5686 7.14048 10.5115 7.24879 10.4092L12.4994 5.45082C12.5563 5.39854 12.6022 5.33547 12.6346 5.26528C12.6669 5.19509 12.685 5.11918 12.6877 5.04195C12.6904 4.96472 12.6778 4.88771 12.6505 4.8154C12.6233 4.74309 12.5819 4.67692 12.5289 4.62074C12.4758 4.56455 12.4121 4.51947 12.3415 4.4881C12.2709 4.45674 12.1947 4.43972 12.1174 4.43804C12.0402 4.43636 11.9634 4.45004 11.8914 4.4783C11.8195 4.50656 11.7539 4.54883 11.6985 4.60265L6.84804 9.18299L1.99879 4.60265Z"
                                fill="black"
                                fillOpacity="0.2"
                              />
                            </svg>
                          </span>
                        </div>
                      </th>
                      <th>
                        <div className="d-flex gap-1  align-items-center">
                          <p className="table-label">State</p>
                          <span>
                            <svg
                              width="14"
                              height="15"
                              viewBox="0 0 14 15"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1.99879 4.60265C1.94309 4.55003 1.87758 4.50888 1.80599 4.48157C1.7344 4.45427 1.65813 4.44132 1.58154 4.44349C1.50494 4.44566 1.42953 4.46289 1.35959 4.4942C1.28966 4.52551 1.22658 4.5703 1.17395 4.62599C1.12132 4.68168 1.08018 4.74719 1.05287 4.81878C1.02556 4.89037 1.01262 4.96664 1.01479 5.04324C1.01696 5.11983 1.03419 5.19525 1.0655 5.26518C1.09681 5.33511 1.14159 5.39819 1.19729 5.45082L6.44729 10.4092C6.55559 10.5115 6.69899 10.5686 6.84804 10.5686C6.99708 10.5686 7.14048 10.5115 7.24879 10.4092L12.4994 5.45082C12.5563 5.39854 12.6022 5.33547 12.6346 5.26528C12.6669 5.19509 12.685 5.11918 12.6877 5.04195C12.6904 4.96472 12.6778 4.88771 12.6505 4.8154C12.6233 4.74309 12.5819 4.67692 12.5289 4.62074C12.4758 4.56455 12.4121 4.51947 12.3415 4.4881C12.2709 4.45674 12.1947 4.43972 12.1174 4.43804C12.0402 4.43636 11.9634 4.45004 11.8914 4.4783C11.8195 4.50656 11.7539 4.54883 11.6985 4.60265L6.84804 9.18299L1.99879 4.60265Z"
                                fill="#8E8F95"
                              />
                              <path
                                d="M1.99879 4.60265C1.94309 4.55003 1.87758 4.50888 1.80599 4.48157C1.7344 4.45427 1.65813 4.44132 1.58154 4.44349C1.50494 4.44566 1.42953 4.46289 1.35959 4.4942C1.28966 4.52551 1.22658 4.5703 1.17395 4.62599C1.12132 4.68168 1.08018 4.74719 1.05287 4.81878C1.02556 4.89037 1.01262 4.96664 1.01479 5.04324C1.01696 5.11983 1.03419 5.19525 1.0655 5.26518C1.09681 5.33511 1.14159 5.39819 1.19729 5.45082L6.44729 10.4092C6.55559 10.5115 6.69899 10.5686 6.84804 10.5686C6.99708 10.5686 7.14048 10.5115 7.24879 10.4092L12.4994 5.45082C12.5563 5.39854 12.6022 5.33547 12.6346 5.26528C12.6669 5.19509 12.685 5.11918 12.6877 5.04195C12.6904 4.96472 12.6778 4.88771 12.6505 4.8154C12.6233 4.74309 12.5819 4.67692 12.5289 4.62074C12.4758 4.56455 12.4121 4.51947 12.3415 4.4881C12.2709 4.45674 12.1947 4.43972 12.1174 4.43804C12.0402 4.43636 11.9634 4.45004 11.8914 4.4783C11.8195 4.50656 11.7539 4.54883 11.6985 4.60265L6.84804 9.18299L1.99879 4.60265Z"
                                fill="black"
                                fillOpacity="0.2"
                              />
                            </svg>
                          </span>
                        </div>
                      </th>
                      <th>
                        <p className="table-label">Action</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {brokers?.map((item, idx) => (
                      <tr key={idx}>
                        <td>
                          <p className="value">{item?.broker_name}</p>
                        </td>
                        <td>
                          <p className="value">{item?.username}</p>
                        </td>
                        <td>
                          <p className="value">
                            {item?.exchanges?.join(", ")}{" "}
                          </p>
                        </td>
                        <td>
                          <p className="value">
                            {item?.state_cd === "A" ? "Active" : "Inactive"}{" "}
                          </p>
                        </td>
                        <td>
                          <div className="action d-flex align-items-center gap-2">
                            <button
                              className="edit d-flex justify-content-center align-items-center p-1 mr-1"
                              onClick={() => {
                                item["action"] = "UPDATE";

                                setValues(item);
                                setAddBroker(!addBroker);
                                setInput(brokerjson[item?.broker_name].fields);
                                setBrokerDisable(false);
                              }}
                            >
                              <CiEdit />
                            </button>
                            <button
                              className="delete d-flex justify-content-center align-items-center p-1"
                              onClick={() => openModal(item)}
                            >
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M4.92862 2.57146H7.07148C7.07148 2.2873 6.9586 2.01478 6.75767 1.81385C6.55673 1.61292 6.28421 1.50003 6.00005 1.50003C5.71589 1.50003 5.44337 1.61292 5.24244 1.81385C5.04151 2.01478 4.92862 2.2873 4.92862 2.57146ZM4.28577 2.57146C4.28577 2.11681 4.46638 1.68077 4.78787 1.35928C5.10936 1.03779 5.5454 0.857178 6.00005 0.857178C6.45471 0.857178 6.89074 1.03779 7.21224 1.35928C7.53373 1.68077 7.71434 2.11681 7.71434 2.57146H10.3929C10.4782 2.57146 10.5599 2.60533 10.6202 2.66561C10.6805 2.72589 10.7143 2.80764 10.7143 2.89289C10.7143 2.97814 10.6805 3.0599 10.6202 3.12018C10.5599 3.18046 10.4782 3.21432 10.3929 3.21432H9.83148L9.30991 9.47275C9.27196 9.92803 9.06431 10.3524 8.72812 10.6618C8.39194 10.9711 7.95177 11.1429 7.49491 11.1429H4.5052C4.04833 11.1429 3.60817 10.9711 3.27198 10.6618C2.9358 10.3524 2.72814 9.92803 2.6902 9.47275L2.16862 3.21432H1.6072C1.52195 3.21432 1.44019 3.18046 1.37991 3.12018C1.31963 3.0599 1.28577 2.97814 1.28577 2.89289C1.28577 2.80764 1.31963 2.72589 1.37991 2.66561C1.44019 2.60533 1.52195 2.57146 1.6072 2.57146H4.28577ZM3.33091 9.41918C3.35542 9.71378 3.48975 9.98842 3.70726 10.1886C3.92477 10.3888 4.20957 10.5 4.5052 10.5H7.49491C7.79053 10.5 8.07534 10.3888 8.29285 10.1886C8.51036 9.98842 8.64469 9.71378 8.6692 9.41918L9.18691 3.21432H2.81362L3.33091 9.41918ZM5.03577 4.71432C5.12101 4.71432 5.20277 4.74819 5.26305 4.80847C5.32333 4.86874 5.3572 4.9505 5.3572 5.03575V8.67861C5.3572 8.76386 5.32333 8.84561 5.26305 8.90589C5.20277 8.96617 5.12101 9.00004 5.03577 9.00004C4.95052 9.00004 4.86876 8.96617 4.80848 8.90589C4.7482 8.84561 4.71434 8.76386 4.71434 8.67861V5.03575C4.71434 4.9505 4.7482 4.86874 4.80848 4.80847C4.86876 4.74819 4.95052 4.71432 5.03577 4.71432ZM7.28577 5.03575C7.28577 4.9505 7.2519 4.86874 7.19162 4.80847C7.13134 4.74819 7.04959 4.71432 6.96434 4.71432C6.87909 4.71432 6.79733 4.74819 6.73705 4.80847C6.67677 4.86874 6.64291 4.9505 6.64291 5.03575V8.67861C6.64291 8.76386 6.67677 8.84561 6.73705 8.90589C6.79733 8.96617 6.87909 9.00004 6.96434 9.00004C7.04959 9.00004 7.13134 8.96617 7.19162 8.90589C7.2519 8.84561 7.28577 8.76386 7.28577 8.67861V5.03575Z"
                                  fill="currentColor"
                                />
                                <path
                                  d="M4.92862 2.57146H7.07148C7.07148 2.2873 6.9586 2.01478 6.75767 1.81385C6.55673 1.61292 6.28421 1.50003 6.00005 1.50003C5.71589 1.50003 5.44337 1.61292 5.24244 1.81385C5.04151 2.01478 4.92862 2.2873 4.92862 2.57146ZM4.28577 2.57146C4.28577 2.11681 4.46638 1.68077 4.78787 1.35928C5.10936 1.03779 5.5454 0.857178 6.00005 0.857178C6.45471 0.857178 6.89074 1.03779 7.21224 1.35928C7.53373 1.68077 7.71434 2.11681 7.71434 2.57146H10.3929C10.4782 2.57146 10.5599 2.60533 10.6202 2.66561C10.6805 2.72589 10.7143 2.80764 10.7143 2.89289C10.7143 2.97814 10.6805 3.0599 10.6202 3.12018C10.5599 3.18046 10.4782 3.21432 10.3929 3.21432H9.83148L9.30991 9.47275C9.27196 9.92803 9.06431 10.3524 8.72812 10.6618C8.39194 10.9711 7.95177 11.1429 7.49491 11.1429H4.5052C4.04833 11.1429 3.60817 10.9711 3.27198 10.6618C2.9358 10.3524 2.72814 9.92803 2.6902 9.47275L2.16862 3.21432H1.6072C1.52195 3.21432 1.44019 3.18046 1.37991 3.12018C1.31963 3.0599 1.28577 2.97814 1.28577 2.89289C1.28577 2.80764 1.31963 2.72589 1.37991 2.66561C1.44019 2.60533 1.52195 2.57146 1.6072 2.57146H4.28577ZM3.33091 9.41918C3.35542 9.71378 3.48975 9.98842 3.70726 10.1886C3.92477 10.3888 4.20957 10.5 4.5052 10.5H7.49491C7.79053 10.5 8.07534 10.3888 8.29285 10.1886C8.51036 9.98842 8.64469 9.71378 8.6692 9.41918L9.18691 3.21432H2.81362L3.33091 9.41918ZM5.03577 4.71432C5.12101 4.71432 5.20277 4.74819 5.26305 4.80847C5.32333 4.86874 5.3572 4.9505 5.3572 5.03575V8.67861C5.3572 8.76386 5.32333 8.84561 5.26305 8.90589C5.20277 8.96617 5.12101 9.00004 5.03577 9.00004C4.95052 9.00004 4.86876 8.96617 4.80848 8.90589C4.7482 8.84561 4.71434 8.76386 4.71434 8.67861V5.03575C4.71434 4.9505 4.7482 4.86874 4.80848 4.80847C4.86876 4.74819 4.95052 4.71432 5.03577 4.71432ZM7.28577 5.03575C7.28577 4.9505 7.2519 4.86874 7.19162 4.80847C7.13134 4.74819 7.04959 4.71432 6.96434 4.71432C6.87909 4.71432 6.79733 4.74819 6.73705 4.80847C6.67677 4.86874 6.64291 4.9505 6.64291 5.03575V8.67861C6.64291 8.76386 6.67677 8.84561 6.73705 8.90589C6.79733 8.96617 6.87909 9.00004 6.96434 9.00004C7.04959 9.00004 7.13134 8.96617 7.19162 8.90589C7.2519 8.84561 7.28577 8.76386 7.28577 8.67861V5.03575Z"
                                  fill="black"
                                  fillOpacity="0.2"
                                />
                              </svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </Tab>
          <Tab eventKey="notification" title="Notification">
            <div className="notification-page-wrapper">
              {/* Header with filters */}
              <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                <h5 className="mb-0">Notifications</h5>
                <div className="d-flex gap-2">
                  <button 
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => markAllAsRead()}
                    disabled={!hasUnreadNotifications()}
                  >
                    Mark all as read
                  </button>
                  <select 
                    className="form-select form-select-sm" 
                    style={{width: 'auto'}}
                    value={notificationFilter}
                    onChange={(e) => filterNotifications(e.target.value)}
                  >
                    <option value="all">All</option>
                    <option value="unread">Unread</option>
                    <option value="read">Read</option>
                  </select>
                </div>
              </div>

              {/* Enhanced notification list */}
              {getFilteredNotifications()?.length > 0 ? (
                <div className="notification-list">
                  {getFilteredNotifications().map((item, idx) => (
                    <div 
                      key={idx} 
                      className={`notification-card-item ${item.read_ind === 'U' ? 'unread' : 'read'}`}
                    >
                      <div className="d-flex align-items-start gap-3 p-3">
                        <div className="notification-icon-wrapper">
                          <img 
                            src={notificationsIcon} 
                            width={32} 
                            className="rounded" 
                            alt="notification" 
                          />
                          {item.read_ind === 'U' && (
                            <span className="unread-badge"></span>
                          )}
                        </div>
                        <div className="flex-grow-1">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                              <span className="notification-type-tag">{item?.type || 'General'}</span>
                              <h6 className="mb-1 mt-1">{item?.content}</h6>
                            </div>
                            <div className="d-flex gap-2">
                              {item.read_ind === 'U' && (
                                <button 
                                  className="btn btn-sm btn-link p-0"
                                  onClick={() => markAsRead(item.notify_id)}
                                  title="Mark as read"
                                >
                                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.5 4L6 11.5L2.5 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                  </svg>
                                </button>
                              )}
                              <button 
                                className="btn btn-sm btn-link text-danger p-0"
                                onClick={() => deleteNotification(item.notify_id)}
                                title="Delete"
                              >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 4L12 12M12 4L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                              </button>
                            </div>
                          </div>
                          {(item.created_at || item.notify_ts || item.timestamp) && (
                            <small className="text-muted">
                              {formatTime(item.created_at || item.notify_ts || item.timestamp)}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="notification-empty-state text-center py-5">
                  <img src={notificationsIcon} width={100} alt="no notifications" style={{opacity: 0.3}} />
                  <p className="mt-3 text-muted">No notifications found</p>
                </div>
              )}

              {/* Pagination */}
              {getFilteredNotifications()?.length > 0 && (
                <div className="mt-4">
                  <PaginationComponent
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={(page) => { setcurrentPage(page); getNotification(page) }}
                  />
                </div>
              )}
            </div>
            {/* <div className="notification-pagination d-flex justify-content-center pt-1">
          <Pagination>
            <Pagination.First>
              <FaAnglesLeft />
            </Pagination.First>
            <Pagination.Prev>
              <FaAngleLeft />
            </Pagination.Prev>
            <Pagination.Item active>{1}</Pagination.Item>
            <Pagination.Item>{2}</Pagination.Item>
            <Pagination.Item>{3}</Pagination.Item>
            <Pagination.Ellipsis />
            <Pagination.Item>{10}</Pagination.Item>
            <Pagination.Next>
              <FaAngleRight />
            </Pagination.Next>
            <Pagination.Last>
              <FaAnglesRight />
            </Pagination.Last>
          </Pagination>
        </div> */}
          </Tab>
        </Tabs>
      </div>
      {addBroker && (
        <div
          className={`broken-modal align-items-center justify-content-end  p-3 p-md-4 position-fixed top-0 start-0 w-100 z-2 bg-black bg-opacity-20 h-100  `}
        >
          <div className="login-otp-wrap bg-white py-4 px-3 rounded-4 h-100 ms-auto">
            <div className="login-otp-scroll h-100 px-2 d-flex flex-column overflow-auto">
              <div className="login-popup-header position-sticky top-0 start-0 z-2 w-100 bg-white d-flex align-items-center gap-2 mb-3 pb-md-1">
                <button
                  onClick={() => {
                    setValues(initialValues);
                    setAddBroker(!addBroker);
                  }}
                  className="login-close text-body d-flex align-items-center justify-content-center rounded-pill border-0 p-0"
                >
                  <LiaAngleLeftSolid />
                </button>
                <h4 className="mb-0">
                  {!isBrokerFieldDisabled ? "Update Broker" : "Add New Broker"}
                </h4>

                <div className="text-danger fs-12">{errors}</div>
              </div>
              <div className="link-item mb-3">
                <p className="fs-6 fw-medium mb-2">Setup Link</p>
                <a
                  className="fs-14 fw-medium"
                  target="_blank"
                  href={
                    values.broker_name
                      ? brokerjson[values?.broker_name]?.setuplink
                      : "https://tradetron.tech/html-view/Configure-ABSTOX"
                  }
                >
                  {values.broker_name
                    ? brokerjson[values?.broker_name]?.setuplink
                    : "https://tradetron.tech/html-view/Configure-ABSTOX"}
                </a>
              </div>
              <div className="select2 mb-3">
                <Select
                  name="broker_name"
                  options={options}
                  value={
                    options.find(
                      (option) => option.value === values.broker_name
                    ) || ""
                  }
                  onChange={handleSelectChange}
                  isDisabled={!isBrokerFieldDisabled}
                  placeholder="Select Broker"
                  label="Select Broker"
                />
              </div>
              <div className="line w-100 mb-3"></div>
              <p className="broken-contact mb-3">Connect to Broker</p>
              {input.map((field, index) => (
                <div className="mb-4  mb-lg-3">
                  {/* <FormBox type="text" name="secret_key" value={values.secret_key} onChange={handlechangeValues} label="Secret_Key" placeholder="Type here" /> */}

                  {(field.type === "text" ||
                    field.type === "password" ||
                    field.type === "number") && (
                      <FormBox
                        key={index}
                        // error={errors[field.field_name]}
                        type={field.type}
                        name={field.field_name}
                        value={values[field.field_name]}
                        onChange={(e) =>
                          setValues({
                            ...values,
                            [field.field_name]: e.target.value,
                          })
                        }
                        disabled={
                          field.field_name === "username"
                            ? !isBrokerFieldDisabled
                            : false
                        }
                        label={field.display_name}
                        placeholder="Type Here "
                      />
                    )}
                  {field.type === "multiselect" && (
                    <Select
                      key={index}
                      name={field.field_name}
                      defaultValue={
                        field.value && values[field.field_name]
                          ? convertarraytoobject(field.value)?.filter((val) =>
                            values[field.field_name].includes(val.value)
                          )
                          : []
                      }
                      onChange={(selectedOptions) => {
                        setValues({
                          ...values,
                          [field.field_name]: selectedOptions.map(
                            (option) => option.value
                          ),
                        });
                      }}
                      options={convertarraytoobject(field.value)}
                      isMulti
                      placeholder={`Select ${field.display_name}`}
                    />
                  )}
                </div>
              ))}
              {/* <div className="mb-4 mb-lg-5">
                <FormBox type="text" name="api_key" label="api_Key" value={values.api_key} onChange={handlechangeValues} placeholder="Type here" />
              </div> */}
              <div className="d-flex gap-2 mt-auto btns">
                <button
                  to="#"
                  className="btn bg-transparent w-50 fs-14"
                  onClick={() => setAddBroker(false)}
                >
                  Back
                </button>
                <button
                  to="#"
                  className="btn bg-primary w-50 fs-14"
                  onClick={createBrokers}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {DelModal && (
        <div
          className={`login-otp align-items-center justify-content-center p-3 position-fixed top-0 start-0 w-100 z-2 bg-black bg-opacity-20 h-100 ${DelModal ? "d-flex" : "d-none"
            }`}
        >
          <div className="login-otp-wrap bg-white p-3 p-md-4 rounded-4">
            <div className="login-popup-header d-flex align-items-center gap-2 mb-3 pb-md-1">
              <button
                className="login-close text-body d-flex align-items-center justify-content-center rounded-pill border-0 p-0"
                onClick={() => {
                  setDelModal(false);
                }}
              >
                <LiaAngleLeftSolid />
              </button>
              <h4 className="mb-0">Delete Broker</h4>
            </div>
            <p className="mb-3 fs-14 fw-medium text-heading text-center ">
              Are you sure want to delete Entries for {DelItem.broker_name} -{" "}
              {DelItem.username}
            </p>
            <div className="row d-flex justify-content-center align-items-center">
              <button
                onClick={() => {
                  DelItem["action"] = "DELETE";
                  createBrokers(DelItem);
                }}
                className="btn bg-primary col-5 fs-14 mx-2"
              >
                Yes
              </button>
              <button
                onClick={() => setDelModal(false)}
                className="btn bg-primary col-5 fs-14 mx-2"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
